import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./ZleceniaStyle/SzczegolyZlecenia.css";
import ZlecenieKosztySprzedazPodglad from "./ZlecenieKosztySprzedazPodglad";
const API_URL = process.env.REACT_APP_API_URL;

function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleString("pl-PL");
}

function SzczegolyZlecenia({ zlecenieId, onZamknij, onGenerujPDF }) {
  const [loading, setLoading] = useState(true);
  const [daneZlecenia, setDaneZlecenia] = useState(null);
  const [clientInfo, setClientInfo] = useState(null);
  const [adresInfo, setAdresInfo] = useState(null);
  const [previewMap, setPreviewMap] = useState({});
  const [pliki, setPliki] = useState([]);
  const [opiekun, setOpiekun] = useState([]);
  const ksRef = useRef(null);


  useEffect(() => {
    const fetchDane = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get(`${API_URL}/zlecenia/${zlecenieId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDaneZlecenia(res.data);

        const opiek = await axios.get(`${API_URL}/pracownicy/${res.data.opiekun_zlecenia}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOpiekun(opiek.data);


        const adres = await axios.get(`${API_URL}/adresy/${res.data.id_adres}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAdresInfo(adres.data);

        if (adres.data.id_klient) {
          const klient = await axios.get(`${API_URL}/klienci/${adres.data.id_klient}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setClientInfo(klient.data);
        }

        const plikiRes = await axios.get(`${API_URL}/pliki_zlecenia/zlecenia?id_zlecenia=${zlecenieId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPliki(plikiRes.data);
      } catch (err) {
        console.error("Błąd podczas pobierania danych zlecenia:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDane();
  }, [zlecenieId]);

useEffect(() => {
  /** Pobiera i buduje podglądy wszystkich plików w `pliki`. */
  const fetchPreview = async () => {
    const token = localStorage.getItem('token');

    for (const f of pliki) {
      // Jeśli dla danego pliku URL podglądu już istnieje – pomijamy.
      if (previewMap[f.id_pliku]) continue;

      try {
        // 1️⃣  pobieramy sam plik jako BLOB
        const blobRes = await axios.get(
          `${API_URL}/pliki_zlecenia/${f.id_pliku}`,
          {
            responseType: 'blob',
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        // 2️⃣  tworzymy Object‑URL i dokładamy go do mapy
        const objectUrl = URL.createObjectURL(blobRes.data);
        setPreviewMap((prev) => ({ ...prev, [f.id_pliku]: objectUrl }));
      } catch (err) {
        console.error('Błąd pobierania podglądu pliku:', err);
      }
    }
  };

  if (pliki.length) fetchPreview();

  // 3️⃣  cleanup: zwalniamy pamięć Object‑URL‑i
  return () => {
    Object.values(previewMap).forEach((url) => URL.revokeObjectURL(url));
  };
}, [pliki]);

  

  if (loading || !daneZlecenia) return <div>Ładowanie...</div>;

  return (
    <div className="modal">
      <div className="modal-content szczegoly-zlecenia">
        <div className="header-bar">
          <h3>Szczegóły zlecenia #{daneZlecenia.numer_zlecenia}</h3>
          <div className="header-actions">
            <button
              className="pdf-button"
              onClick={() => {
                const extra = ksRef.current?.getPdfContent?.() || [];
                onGenerujPDF(extra);
              }}
              >
              Generuj PDF
              </button>
            <button className="close-button" onClick={onZamknij}>✖</button>
          </div>
        </div>

        <div className="info-grid">
          <div className="info-card">
            <h4>Klient</h4>
            {clientInfo ? (
              <>
                <p><strong>{clientInfo.imie} {clientInfo.nazwisko}</strong></p>
                <p>{clientInfo.adres_email}</p>
                <p>{clientInfo.nr_telefonu}</p>
              </>
            ) : <p>Brak danych</p>}
          </div>

          <div className="info-card">
            <h4>Adres</h4>
            {adresInfo ? (
              <>
                <p>{adresInfo.ulica} {adresInfo.nr_domu} {adresInfo.nr_lokalu ? ' / ' + adresInfo.nr_lokalu : ''}</p>
                <p>{adresInfo.miasto}, {adresInfo.kod_pocztowy}</p>
              </>
            ) : <p>Brak danych</p>}
          </div>
        </div>

        <div className="order-details-grid">
            <div className="order-details-column-grid-left"> 

                <div className="order-details-table">
                    <table>
                        <tbody>
                            <tr>
                                <td><strong>Rodzaj zlecenia:</strong></td>
                                <td>{daneZlecenia.rodzaj_zlecenia}</td>
                            </tr>
                            <tr>
                                <td><strong>Status:</strong></td>
                                <td>{daneZlecenia.status}</td>
                            </tr>
                            <tr>
                                <td><strong>Planowana data realizacji:</strong></td>
                                <td>{formatDate(daneZlecenia.planowana_data_realizacji)}</td>
                            </tr>
                            <tr>
                                <td><strong>Opis:</strong></td>
                                <td>{daneZlecenia.opis || '-'}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="order-details-table">
                    <table>
                        <tbody>
                            <tr>
                                <td><strong>Opis prac:</strong></td>
                                <td>{daneZlecenia.opis_prac || '-'}</td>
                            </tr>
                            <tr>
                                <td><strong>Data realizacji od:</strong></td>
                                <td>{formatDate(daneZlecenia.data_realizacji_od)}</td>
                            </tr>
                            <tr>
                                <td><strong>Data realizacji do:</strong></td>
                                <td>{formatDate(daneZlecenia.data_realizacji_do)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <ZlecenieKosztySprzedazPodglad ref={ksRef} zlecenieId={zlecenieId} />

                
            </div>
            <div className="order-details-column-grid-right">
                <div className="order-details-row">
                    <div className="detail-row"><strong>Opiekun zlecenia:</strong> <br/> {opiekun.imie} {opiekun.nazwisko}</div>
                </div>
                <div className="order-details-row">
                    <div className="detail-row"><strong>Pracownicy:</strong>   
                    {daneZlecenia.pracownicy.map(f => (
                        <div key={f.id}>
                            <div>{f.imie} {f.nazwisko}</div>
                        </div>
                    ))}

                    </div>
                </div>
            </div>
        </div>

        <div className="order-files">
          {pliki.length > 0 && <h4>Załączone pliki</h4>}
          <div className="thumbnails">
            {pliki.map(f => (
              <div key={f.id_pliku} className="thumb">
                {previewMap[f.id_pliku] ? (
                  // dla obrazków
                  f.typ_pliku.startsWith("image/") ? (
                    <a
                      href={previewMap[f.id_pliku]}
                      download={f.nazwa_oryginalna}
                    >
                      <img
                        src={previewMap[f.id_pliku]}
                        alt={f.nazwa_oryginalna}
                      />
                    </a>
                  ) : (
                    // dla PDF i innych plików – ikona pobrania
                    <a
                      href={previewMap[f.id_pliku]}
                      download={f.nazwa_oryginalna}
                      className="file-icon"
                    >
                      📄 {f.nazwa_oryginalna}
                    </a>
                  )
                ) : (
                  <div className="skeleton" />
                )}
              </div>
            ))}
          </div>
        </div>

        
            
      </div>
    </div>
  );
}

export default SzczegolyZlecenia;
